export default __webpack_public_path__ + "static/559-aad15f0b507695c089056b0c9b03799a.gif";